
const m = window.require("@ember/routing/none-location");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
